import React from 'react'
import Pt from 'prop-types'
import Ipt from 'react-immutable-proptypes'
import { connect } from 'react-redux'
import {
  Button,
  Col,
  FormControl,
  FormGroup,
  InputGroup,
  PageHeader,
  Panel,
  Row,
} from 'react-bootstrap'
import copy from 'copy-to-clipboard'

import { PartnerRecord } from 'internal-components/src/records'
import { selectPartnerAccess } from 'internal-components/src/redux/modules/partner/selectors'
import { loadPartnerAccess } from 'internal-components/src/redux/modules/partner/reducer'
import { makeSelectLoading } from 'internal-components/src/redux/modules/loading'

import PageLoading from '../../components/Layout/PageLoading'
import { beginPartner } from '../../redux/modules/signupEdit/actions'

export class DashboardView extends React.Component {
  componentWillMount() {
    this.props.loadPartnerAccess()
  }

  render() {
    return (
      <section className="container">
        <PageHeader>Partner Signup Management</PageHeader>

        {this.props.loading && <PageLoading />}

        {!this.props.loading &&
          !this.props.partners.size && (
            <p>
              You do not have access to create pre-filled signups on behalf of a
              partner.
            </p>
          )}

        {this.props.partners.map(p => {
          const partnerUrl = `https://portal.infinite.net.au/auth?partner=${encodeURIComponent(
            p.authHash,
          )}`

          return (
            <Panel key={p.id}>
              <Panel.Body>
                <h3>{p.name}</h3>
                <Row>
                  <Col md={6}>
                    <h4>Create Signup</h4>

                    <p>
                      Create a new pre-filled signup for your clients to
                      approve. They will be notified of the creation and will
                      need to provide payment information and agree to our terms
                      and conditions.
                    </p>

                    <Button
                      bsSize="lg"
                      onClick={() => this.props.beginPartner(p.id)}
                    >
                      Create Signup
                    </Button>
                  </Col>

                  <Col md={6}>
                    <h4>Adding Clients</h4>

                    <p>
                      To add existing customers of Infinite Networks to your
                      partner account, the customer must visit the customer
                      portal and authorise the link.
                    </p>

                    <p>
                      You can send our mutual customers to the following page to
                      authorise you:
                    </p>

                    <FormGroup>
                      <InputGroup>
                        <FormControl
                          readOnly
                          disabled
                          type="text"
                          value={partnerUrl}
                        />
                        <InputGroup.Button onClick={() => copy(partnerUrl)}>
                          <Button>Copy</Button>
                        </InputGroup.Button>
                      </InputGroup>
                    </FormGroup>
                  </Col>
                </Row>
              </Panel.Body>
            </Panel>
          )
        })}

        {/* <hr />

        <h2>Current Signups</h2>
        <p>Table of signups</p> */}
      </section>
    )
  }
}

DashboardView.propTypes = {
  beginPartner: Pt.func.isRequired,
  loading: Pt.bool.isRequired,
  loadPartnerAccess: Pt.func.isRequired,
  partners: Ipt.orderedSetOf(Pt.instanceOf(PartnerRecord)).isRequired,
}

const mapStateToProps = () => {
  const selectLoading = makeSelectLoading()

  return state => {
    const partners = selectPartnerAccess(state)

    return {
      loading: selectLoading(state, { type: 'partners' }),
      partners,
    }
  }
}

export default connect(
  mapStateToProps,
  {
    beginPartner,
    loadPartnerAccess,
  },
)(DashboardView)



// WEBPACK FOOTER //
// ./src/views/Msp/DashboardView.jsx